module.exports = __webpack_public_path__ + "static/media/cross.8edc4321.svg";